import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ErrorResponse, gamesCustomAxios } from '@utils/customAxios';

// ------------------------------ DELETE /users/deletion ------------------------------
interface AuthData {
  authKey: string;
  tokenType: string;
  uuid: string;
}

interface UserDeleteResponse {
  data: AuthData;
  message: string;
  code: string;
  authKey?: string;
}

interface UserDeletionRequest {
  phoneNumber: number;
  userId: string;
}

interface UserDeletionRequestOptions {
  request: UserDeletionRequest;
  headers: Record<string, string>;
}

const deleteGamesUserData = (options: UserDeletionRequestOptions): Promise<UserDeleteResponse> => {
  return gamesCustomAxios
    .delete<UserDeleteResponse>('users/deletion', {
      data: options.request,
      headers: options.headers
    })
    .then((res) => res.data);
};

export const useDeleteGamesUserDataMutation = (): UseMutationResult<
  UserDeleteResponse,
  AxiosError<ErrorResponse>,
  UserDeletionRequestOptions,
  unknown
> => {
  return useMutation<UserDeleteResponse, AxiosError<ErrorResponse>, UserDeletionRequestOptions, unknown>({
    mutationFn: deleteGamesUserData
  });
};

// ------------------------------ DELETE /users/deletion ------------------------------
